import AddPage from './AddPage.js'
import { BasePage as CngBasePage } from 'cng-web-lib'
import EditPage from './EditPage.js'
import React from 'react'
import TablePage from './TablePage.js'
import ViewPage from './ViewPage.js'
import useBreadcrumbNameMap from 'src/useBreadcrumbNameMap'
import useMpciToast from '../Common/hooks/useMpciToast'

function WrappedTablePage(props) {
  const breadcrumbNameMap = useBreadcrumbNameMap()
  const { showNotification, toastNode } = useMpciToast()
  return (
    <>
      <CngBasePage
        renderPage={() => <TablePage showNotification={showNotification} {...props} />}
        extraCngBreadcrumbNameMap={breadcrumbNameMap}
      />
      {toastNode}
    </>
  )
}

function WrappedAddPage(props) {
  const breadcrumbNameMap = useBreadcrumbNameMap()
  const { showNotification, toastNode } = useMpciToast()
  return (
    <>
      <CngBasePage
        renderPage={() => <AddPage showNotification={showNotification} {...props} />}
        extraCngBreadcrumbNameMap={breadcrumbNameMap}
      />
      {toastNode}
    </>
  )
}

function WrappedEditPage(props) {
  const breadcrumbNameMap = useBreadcrumbNameMap()
  const { showNotification, toastNode } = useMpciToast()
  return (
    <>
      <CngBasePage
        renderPage={() => <EditPage showNotification={showNotification} {...props} />}
        extraCngBreadcrumbNameMap={breadcrumbNameMap}
      />
      {toastNode}
    </>
  )
}

function WrappedViewPage(props) {
  const breadcrumbNameMap = useBreadcrumbNameMap()
  const { showNotification, toastNode } = useMpciToast()
  return (
    <>
      <CngBasePage
        renderPage={() => <ViewPage showNotification={showNotification} {...props} />}
        extraCngBreadcrumbNameMap={breadcrumbNameMap}
      />
      {toastNode}
    </>
  )
}

export {
  WrappedAddPage as AddPage,
  WrappedEditPage as EditPage,
  WrappedViewPage as ViewPage,
  WrappedTablePage as TablePage
}
